import { Box, Typography } from "@mui/material";
import { CasLoader } from "../brand/CasLoader";
import {
  useFetchSelectedConnectCardListener,
  useNavigateToSelectedConnectCardListener,
  useSelectedConnectorTypeRouterParamListener,
} from "../../hook/pullConnector";
import { NoteBlockContainer, NotePageContainer } from "../note";

export const AddConnectCardPage: React.FC = () => {
  useSelectedConnectorTypeRouterParamListener();
  useFetchSelectedConnectCardListener();
  useNavigateToSelectedConnectCardListener();

  return (
    <NotePageContainer pageName="Pull Connector Creating">
      <NoteBlockContainer name="Creation In Progress">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <CasLoader />
        </Box>
      </NoteBlockContainer>
    </NotePageContainer>
  );
};
